import { adBlockElName } from "@gik/ads/components/AdContainer";
import Link from "@gik/core/components/Link.tsx";

export default function FallbackAd() {
	return (
		<Link href="/create">
			<div className={adBlockElName} />
		</Link>
	);
}
